import { Tooltip } from 'antd';
import styles from './index.module.sass';

export const Requisite = ({ label, value, tooltip = false }: IRequisite) => {
  return (
    <div className={styles.root}>
      <span className={styles.label}>{label}</span>
      {tooltip ? (
        <Tooltip title={value}>
          <span className={styles.value}>{value}</span>
        </Tooltip>
      ) : (
        <span className={styles.value}>{value}</span>
      )}
    </div>
  );
};

interface IRequisite {
  label: any;
  value: string;
  tooltip?: boolean;
}
